import React from "react";
import styled from "styled-components";

const NotificationContainer = styled.div<{ variant?: "warning" | "error" }>`
  height: 66px;
  overflow: hidden;
  position: relative;
  color: #333;
  border: 1px solid #e3e3e3;
  margin-bottom: 20px;

  ${props => {
    switch (props.variant) {
      case "warning":
        return `
          background: #fff3cd;
          border-color: #ffc107;
          color: #856404;
        `;
      case "error":
        return `
         background: linear-gradient(135deg, #fee 0%, #ffebee 100%);
         border-color: #e53e3e;
         color: red;
         border-left: 4px solid red;
        `;
      default:
        return `
          background: #fefefe;
          border-color: #e3e3e3;
          color: #333;
        `;
    }
  }}

  p {
    position: absolute;
    width: 100%;
    height: 100%;
    margin-left: 25px;
    padding-right: 25px;
    display: flex;
    align-items: center;
  }
`;

const MessageContent = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Icon = styled.span`
  font-size: 18px;
  margin-right: 8px;
`;

interface NotificationProps {

  message: string;
  title?: string;
  variant?: "warning"| "error";
  icon?: string;
  show?: boolean;
  className?: string;
}

const NotificationMessage: React.FC<NotificationProps> = ({
  message,
  title,
  variant,
  icon,
  show = true,
  className
}) => {
  if (!show) { return null; }

  const getDefaultIcon = (variant: string) => {
    switch (variant) {
      case "warning": return "⚠️";
      case "error": return "🚨";
      default: return "";
    }
  };

  const displayIcon = icon || getDefaultIcon(variant ?? "");

  return (
    <NotificationContainer variant={variant} className={className}>
      <p>
        <MessageContent>
          {displayIcon && <Icon>{displayIcon}</Icon>}
          {title && <b>{title}:</b>}
          {title ? ` ${message}` : message}
        </MessageContent>
      </p>
    </NotificationContainer>
  );
};

export default NotificationMessage;
